import {
  PeopleTableInfo,
  Person,
} from '@aibees/elephant/feature/search-table-people';
import { useMemo } from 'react';

export function useDisplayJobTitle(
  personData?: Person | PeopleTableInfo | null,
  fallback: string = 'N/A'
): string {
  return useMemo(() => {
    const title =
      personData?.profile?.title ||
      personData?.positionGroups?.[0]?.profile_positions?.[0]?.title ||
      fallback;

    return title;
  }, [personData?.profile?.title, personData?.positionGroups, fallback]);
}
